export default __webpack_public_path__ + "static/media/permitting.f614fffa.svg";